<div class="navigacion">
  <ul>
    <li class="list" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <a [routerLink]="['/']">
        <i class="fi fi-rr-house-chimney"></i>
      </a>
    </li>

    <li class="list" [routerLink]="['/app/analitic', id]" routerLinkActive="active">
      <i class="fi fi-rr-chart-histogram"></i>
    </li>

    <li class="list" [routerLink]="['/app/orders', id]" routerLinkActive="active">
      <i class="fi fi-rr-order-history"></i>
    </li>

    <li class="list" [routerLink]="['/app/products', id]" routerLinkActive="active">
      <i class="fi fi-rr-hamburger-soda"></i>
    </li>

    <li class="list" [routerLink]="['/app/setting', id]" routerLinkActive="active">
      <i class="fi fi-rr-settings"></i>
    </li>

    <li class="list">
      <app-profile class="icon"></app-profile>
    </li>
  </ul>
</div>